import { useSearchParams } from 'react-router-dom';
import {
  getSignedPrivateAccessUrl,
  getSignedPrivateAccessUrlByFile,
  getOrganizationSignedPrivateAccessUrl
} from '../../api/queries';
import { useState, useEffect } from 'react';
import { useToast } from '@morressier/alembic';
import { Layout } from '../../components/Layout';
import * as Sentry from '@sentry/react';

const createSignedAttachmentUrl = (url: string) => {
  if (url.includes('/submission/')) {
    const submissionId = url.match(/submission\/(\w+)/)?.[1]!;

    return getSignedPrivateAccessUrl(submissionId, url);
  } else if (url.includes('/organization/')) {
    const organizationId = url.match(/organization\/(\w+)/)?.[1]!;

    return getOrganizationSignedPrivateAccessUrl(organizationId, url);
  }

  return Promise.resolve(url);
};

export default function AssetAccess() {
  const toast = useToast();
  const [searchParams] = useSearchParams();
  const [signedUrl, setSignedUrl] = useState<string | null>(null);
  const url = searchParams.get('url');
  const fileName = searchParams.get('file');
  const submissionId = searchParams.get('submissionId');

  useEffect(() => {
    const request =
      fileName && submissionId
        ? getSignedPrivateAccessUrlByFile(submissionId, fileName)
        : url
        ? createSignedAttachmentUrl(url)
        : undefined;

    if (!request) return;

    request
      .then(signedUrl => {
        setSignedUrl(signedUrl);

        setTimeout(() => {
          window.location.href = signedUrl;
        }, 500);
      })
      .catch(e => {
        Sentry.captureException(e);

        toast({
          title: `Failed to generate signed URL`,
          description: e.message,
          variant: 'error'
        });
      });
  }, []);

  if (!url && !(fileName && submissionId)) {
    return <Layout width="20rem">Missing URL query param</Layout>;
  }
  if (signedUrl === null) {
    return <Layout width="20rem">Preparing file access…</Layout>;
  }

  return (
    <Layout width="24rem">
      <a href={signedUrl}>
        <u>Click here if the file did not open automatically</u>
      </a>
    </Layout>
  );
}
